import { Enums, Tools } from "../utils";
import api from "./api";

const update = (
  uuid,
  { groups = [], message = "", signals = [], delay = 0, webhooks = [] } = {}
) =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await api.put(`rest/devices/${uuid}/configurations/events`, {
        data: [{ categoryId: 1, groups, message, signals, delay, webhooks }],
      });
      resolve(res);
    } catch (error) {
      reject({ error });
    }
  });

const updateWebhookSignal = (uuid, { signal, ...data }) =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await api.put(
        `/rest/devices/${uuid}/configurations/events/webhooks/signals/${signal}`,
        { data }
      );
      resolve(res);
    } catch (error) {
      reject({ error });
    }
  });

const testWebhookSignal = (uuid, { signal, ...data }) =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await api.post(
        `/rest/devices/${uuid}/configurations/events/webhooks/signals/${signal}/test`
      );
      resolve(res);
    } catch (error) {
      reject({ error });
    }
  });

const testWebhook = (uuid, data = {}) =>
  new Promise(async (resolve, reject) => {
    try {
      resolve(await api.post(`/rest/devices/${uuid}/webhooks/test`, { data }));
    } catch (error) {
      reject({ error });
    }
  });

const event = async (uuid) =>
  new Promise(async (resolve, reject) => {
    try {
      const data = await api.get(`/rest/devices/${uuid}/configurations/events`);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });

export default {
  event,
  update,
  testWebhook,
  testWebhookSignal,
  updateWebhookSignal,
};
